var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.369 12.13a2.014 2.014 0 0 0 0 3.795v1.457a.671.671 0 0 0 1.342 0v-1.457a2.014 2.014 0 0 0 0-3.796V2.613a.671.671 0 0 0-1.342 0v9.516zM9.335 4.07a2.015 2.015 0 0 0 0 3.796v9.516a.671.671 0 0 0 1.342 0V7.866a2.015 2.015 0 0 0 0-3.796V2.613a.671.671 0 0 0-1.342 0V4.07zM3.292 12.132a2.015 2.015 0 0 0 0 3.79v1.46a.671.671 0 0 0 1.342 0v-1.454a2.015 2.015 0 0 0 0-3.802V2.613a.671.671 0 0 0-1.342 0v9.52z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPrice);
export default __webpack_public_path__ + "static/media/filter_price.3caaf0372e1db24c125f3ee79f5c1501.svg";
export { ForwardRef as ReactComponent };